import objectUtils from "@/common/utils/objectUtils";

export interface CookieOptions {
  expires?: Date | number;
  path?: string;
  domain?: string;
  secure?: boolean;
}

let all: Record<string, string> | undefined;

export function getAll() {
  if (typeof all === "undefined") {
    const cookies = document.cookie.split(";");
    const ret: Record<string, string> = {};
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].split("=");
      const key = cookie && cookie.length > 0 ? cookie[0].trim() : undefined;
      const value = cookie && cookie.length > 1 ? cookie[1] : undefined;
      if (key && typeof value !== "undefined") {
        ret[key] = value;
      }
    }
    all = ret;
  }
  return all;
}

export function get(name: string): string | undefined {
  return getAll()[name];
}

/*
 * gets a cookie and parses the json.
 * name - the name of the cookie.
 */
export function getObject(name: string): unknown {
  const value = get(name);
  let ret: unknown = undefined;

  if (typeof value !== "undefined") {
    try {
      ret = JSON.parse(value);
    } catch (e) {
      console.warn(e);
    }
  }

  return ret;
}

/*
 * name - cookie name.
 * value - cookie value.
 * data {
 *    expires (optional) - expiration in seconds from now or Date of expire.
 *    path (optional) - path for the cookie
 *    domain
 *    secure
 * }
 */
export function set(name: string, value: string, data?: CookieOptions) {
  const d = new Date();
  let expires;
  let path;
  let secure;
  let domain;

  data = data || {};

  if (objectUtils.isDate(data.expires)) {
    expires = `;expires=${data.expires.toUTCString()}`;
  } else if (objectUtils.isNumeric(data.expires)) {
    d.setTime(d.getTime() + (data.expires as number) * 1000);

    expires = `;expires=${d.toUTCString()}`;
  } else {
    expires = "";
  }

  if (data.path) {
    path = `;path=${data.path}`;
  } else {
    path = "";
  }

  if (data.domain) {
    domain = `;domain=${data.domain}`;
  } else {
    domain = "";
  }

  if (data.secure) {
    secure = ";secure";
  } else {
    secure = "";
  }

  document.cookie = `${name}=${value}${expires}${path}${domain}${secure}`;
  all = undefined;
}
